'use client';

import { useState, type FC, type ReactNode } from 'react';
import { SponsoredCard } from '@highereducation/hen-ui';
import '../RankingsShortcode/blurb-check-list.css';

export interface SponsoredCardAdapterProps {
  'logo-src'?: string;
  'logo-alt'?: string;
  'sponsor-label'?: string;
  'visit-href'?: string;
  'visit-label'?: string;
  'sponsored-visit'?: string;
  name?: string;
  'name-href'?: string;
  'about-heading'?: string;
  /** Pipe-separated metadata segments, e.g. <code>Austin, TX|4-year|Online</code> */
  'meta-items'?: string;
  children?: ReactNode;
}

function parseMetaItems(raw?: string): string[] | undefined {
  if (!raw?.trim()) return undefined;
  const items = raw
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean);
  return items.length > 0 ? items : undefined;
}

export const SponsoredCardAdapter: FC<SponsoredCardAdapterProps> = ({
  'logo-src': logoSrc,
  'logo-alt': logoAlt = '',
  'sponsor-label': sponsorLabel,
  'visit-href': visitHref,
  'visit-label': visitLabel,
  'sponsored-visit': sponsoredVisitRaw,
  name,
  'name-href': nameHref,
  'about-heading': aboutHeading,
  'meta-items': metaItemsRaw,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const trimmedName = name?.trim() ?? '';
  const trimmedLogo = logoSrc?.trim() ?? '';
  if (!trimmedName || !trimmedLogo) return null;

  const sponsoredVisit = sponsoredVisitRaw !== 'false';
  const metaItems = parseMetaItems(metaItemsRaw);

  const blurb =
    children != null ? (
      <div className='blurb-check-list'>{children}</div>
    ) : null;

  return (
    <SponsoredCard
      sponsorLabel={sponsorLabel}
      visitHref={visitHref}
      visitLabel={visitLabel}
      sponsoredVisit={sponsoredVisit}
      logoSrc={trimmedLogo}
      logoAlt={logoAlt || `${trimmedName} logo`}
      name={trimmedName}
      nameHref={nameHref}
      aboutHeading={aboutHeading}
      metaItems={metaItems}
      expanded={expanded}
      onExpandedChange={setExpanded}
      modalOpen={modalOpen}
      onModalOpenChange={setModalOpen}
    >
      {blurb}
    </SponsoredCard>
  );
};
